import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';

export default Highcharts;
